import { SubTask } from '../../types'
import SharedFormTaskCard from '../../../../../shared_components/Missions/Types/Form'
import useUpdateDropTaskSubmissions from '../../../../../hooks/useUpdateDropTaskSubmissions'

const FormTaskCard = ({
  subtask,
  taskId,
  reward,
  maxReward,
}: {
  subtask: SubTask
  taskId: number
  reward: number
  maxReward?: number
}) => {
  const updateTaskSubmissions = useUpdateDropTaskSubmissions()
  
  return <SharedFormTaskCard
    subtask={subtask}
    taskId={taskId}
    reward={reward}
    updateTaskSubmissions={updateTaskSubmissions}
    isDrop
    maxReward={maxReward}
  />
}

export default FormTaskCard
